import React from 'react';
import {
  Heading1, Heading2, LinkStyled, Paragraph,
} from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Alkohol" activeSidemenu="AlkoholSodavand">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Alkoholsodavand</Heading1>
          <Paragraph>
            Søger du efter det perfekte alternativ til øl og vin? Så er alkoholsodavand et sublimt bud. Hos Skafte finder du et bredt sortiment af smagfulde, lette og læskende drikkevarer med procenter i.
            Gå ombord i vores udvalg af den populære alkoholsodavand: Breezer. Perfekt til en solskinsdag, der kalder på frisk og sød frugtsmag. Du kan også smage en bid af sommeren med en Somersby cider - og hvis det skal være helt særligt, så lad dig friste af de velsmagende og lette cocktails på flaske.
          </Paragraph>
          <Paragraph>
            Skulle du alligevel have lyst til at servere en øl for gæsterne, så tag et kig på vores <LinkStyled to="/oel/daaseoel">dåseøl</LinkStyled> og <LinkStyled to="/oel/flaskeoel">flaskeøl</LinkStyled> i samme omgang.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="alkoholSodavand" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Lækkert udvalg af alkoholsodavand</Heading2>
          <Paragraph>
            Hos Skafte finder du et skønt udvalg af alkoholsodavand. Fra søde, sprøde, frugtagtige Breezers til delikate og forfriskende Somersby ciders, og lækre, færdigblandede cocktails på flaske - vi har en variant, der passer til enhver smag. Gør dig klar til at udforske et spændende landskab af smag og forfriskning med alkoholprocenter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Alkoholsodavand: Breezers</Heading2>
          <Paragraph>
            Breezers er kendt for deres farverige, tropiske smag og lette, forfriskende fornøjelse. Hos Skafte fører vi flere forskellige smagsvarianter, herunder den klassiske med appelsin, en med ananas samt en med lemonsmag. Uanset hvilken en du vælger, så er en Breezer det perfekte valg til en afslappet eftermiddag i solen eller en festlig aften.
          </Paragraph>
          <Paragraph>
            Undgå at betale de høje priser i supermarkederne og slæbe flaskerne hjem selv, når du kan købe billige Breezers hos os - og endda få leveret direkte til døren.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Somersby Cider</Heading2>
          <Paragraph>
            Som alternativ til alkoholsodavand er Somersby cider en sand klassiker. Den søde og let syrlige smag af æble kombineret med en sprød og forfriskende finish gør Somersby til den perfekte tørstslukker. Med Somersby er det altid sommer, uanset vejret.
            Vælg mellem flere smagsvarianter, herunder den helt klassiske variant med æblesmag eller den nyere tilføjelse i Somersby sortimentet med brombærsmag.
          </Paragraph>
          <Paragraph>
            Hos Skafte finder du billig Somersby på enten dåse eller flaske - perfekt til en hyggelig aften med vennerne eller en weekend i solen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Cocktails på flaske</Heading2>
          <Paragraph>
            Der er noget magisk over en velsmagende cocktail, men at lave dem kan ofte være besværligt. Det er her, vores udvalg af cocktails på flaske kommer ind i billedet. Vi tilbyder et bredt udvalg af dine favorit cocktails, der allerede er blandet og klar til at nyde. De er det perfekte alternativ til alkoholsodavand, hvis man ønsker noget med en lidt højere alkoholprocent og knap så sødt.
            Cocktails på flaske kan vælges i flere smagsvarianter, herunder Bramble, Mojito og Passion Martini.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Alkoholsodavand til både privat og erhverv</Heading2>
          <Paragraph>
            Hvad enten om du køber ind til virksomheden eller derhjemme, så tilbyder Skafte et bredt udvalg af forskellige varianter af alkoholsodavand.
          </Paragraph>
          <Paragraph>
            Vi leverer allerede til en lang række virksomheder og foreninger - også som fast leveringsaftale. Køber du til en virksomhed? Så kan du vælge at se priserne på vores udvalg af alkoholsodavand uden moms, ved at klikke oppe i højre hjørne.
          </Paragraph>
          <Paragraph>
            Køber du derimod ind til dit eget lille private lager? Måske skal du holde fest? Vi leverer hjertens gerne alkoholsodavand, cider og cocktails på flaske direkte til døren. Bestil inden kl. 17 og vi leverer næste hverdag.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
